import {
  ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit, ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {ApiService} from "../shared/api.service";
import {ContactData} from "./contact.schema";
import {ContactService} from "../shared/contact.service";

declare let $:any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'contacts',
  styles: [ require('./contacts.component.css') ],
  template: require('./contacts.component.html')
})
export class ContactsComponent implements OnInit {

  isBrowser: boolean;

  contactData: ContactData;
  captcha: string;
  subjects: any;
  activeSubject: string;

  @ViewChild("contactModalDiv") contactModalDiv: ElementRef;

  constructor(private apiService: ApiService, private contactService: ContactService, @Inject('isBrowser') isBrowser: boolean){
    this.isBrowser = isBrowser;
  }

  ngOnInit(): void {
    this.contactData = new ContactData();

    if(this.isBrowser){
      this.initAnimations();
      $("#contactCarousel").carousel({ interval: 2000 });
    }


    this.apiService.get('/api/contact/subjects')
      .subscribe(res => this.subjects = res);

  }

  getCaptcha(){
    this.contactService.getCaptcha()
      .subscribe(res => this.captcha = res);
  }

  initAnimations(){
    $(".office-Gabrovo").click(function() {

    $('html,body').animate({
        scrollTop: $(".first-scroll").offset().top
      },'slow');

    });

    $(".office-Tyrgovishte").click(function() {

    $('html,body').animate({
        scrollTop: $(".second-scroll").offset().top
      }, 'slow');

    });
  }

  openModal(){
    this.getCaptcha();
    $(".modal-content").show();
    $(".message-wrapper").hide();
    $(this.contactModalDiv.nativeElement).modal('show');
  }

  closeModal(){
    $(this.contactModalDiv.nativeElement).modal('hide');
  }

  sendContact(){
    this.contactService.sendContact(this.contactData)
      .subscribe((res)=>{
        this.contactData = new ContactData();
        this.captcha = res.captcha;
        $(".modal-content").hide();
        $(".message-wrapper").css("display", "flex");
        setTimeout(() =>{
            this.closeModal();
        }, 2000);
      });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+contacts/contacts.component.ts